import { useEffect, useState } from "react"
import "../Stylesheets/Header/Header.css"
import {Modal, Button} from 'react-bootstrap'
import {Bell, Gear, List, PersonDown, Lock, BoxArrowLeft} from "react-bootstrap-icons"
import { Link } from "react-router-dom";
import OutsideClickHandler from 'react-outside-click-handler';
import axios from "axios";

const Header = ({setShowFullWidth, setNotification}) => {
    const [notifications, setNotifications] = useState([]);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState({show: false, data: {}});
    const [showNotification, setShowNotification] = useState(false);
    const [notificationData, setNotificationData] = useState({reads: [], unreadCount: 0});

    const handlers = {
        logout(){
            axios.post('/api/extension/v1/logout')
                .then(() => {
                    window.location.href="/"
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
        },
        setAsRead(id){
            axios.post(`/api/extension/v1/notification/${id}/is-read`)
                .then(() => {
                    axios.get('/api/extension/v1/read-notifications')
                        .then((resp) => {
                            const unreads = notifications.length - resp.data.data.length;
                            setNotificationData({reads: resp.data.data, unreadCount: unreads});
                        })
                        .catch(() => {
                            setNotifications([]);
                        })
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                })
        },
        loadNotifications(){
            axios.get('/api/extension/v1/notifications')
                .then((res) => {
                    setNotifications(res.data.data);
                    axios.get('/api/extension/v1/read-notifications')
                        .then((resp) => {
                            const unreads = res.data.data.length - resp.data.data.length;
                            setNotificationData({reads: resp.data.data, unreadCount: unreads});
                        })
                        .catch(() => {

                        })
                })
                .catch(() => {
                    setNotifications([]);
                })
        }
    }

    useEffect(() => {
        handlers.loadNotifications();
        setInterval(handlers.loadNotifications, 1000 * 120)
    }, [])

    return(
        <>
            <header className="header-cotnainer">
                <div className="header-left-side-items">
                    <List onClick={() => setShowFullWidth((prev) => !prev)} className="header-menu-icon" />
                </div>
                <div className="header-right-side">
                    <div className="notifications-container">
                        <button className="notification-button" onClick={() => setShowNotification(true)}><Bell />{notificationData.unreadCount > 0 && <span></span>}</button>
                        {showNotification && <OutsideClickHandler onOutsideClick={() => setShowNotification(false)}> <div className="noftications-box">
                            <h6 className="notifications-box-title">Notifications</h6>
                            {(notifications.length == 0 && !loading) && <span className="empty-notifications">No Unread Notifications</span>}
                            {
                                notifications.map((notification, key) => {
                                    return (<div className={`notification-item ${notificationData.reads.includes(JSON.stringify(notification.id)) ? "" : "unread-notifications"}`} key={key} onClick={() => {
                                        setModal({show: true, data: {title: notification.title, html: notification.html, color: notification.alert_type}});
                                        handlers.setAsRead(notification.id);
                                        setShowNotification(false);
                                    }}>
                                        <span className="notification-item-title" style={{color: notification.alert_type}}>{notification.title}</span>
                                        <span className="notification-item-body">{notification.html}</span>
                                    </div>)
                                })
                            }
                        </div></OutsideClickHandler>}
                    </div>
                    <div className="profile-dropdown-button">
                        <button className="profile-dropdown-btn" onClick={() => setShowProfileDropdown(true)}><PersonDown /></button>
                        {showProfileDropdown && <OutsideClickHandler onOutsideClick={() => setShowProfileDropdown(false)}> <div className="profile-dropdown-box">
                            <ul>
                                <li><Link to="/account-settings"><Gear /><span>Account Settings</span></Link></li>
                            </ul>
                            <ul>
                                <li><Lock /><span>Change Password</span></li>
                            </ul>
                            <ul>
                                <li onClick={handlers.logout}><BoxArrowLeft /><span>Log Out</span></li>
                            </ul>
                        </div></OutsideClickHandler>}
                    </div>
                </div>
            </header>
            <Modal show={modal.show} onHide={() => setModal((prev) => ({...prev, show: false}))} size="md">
                <Modal.Header closeButton><div style={{display: "flex", alignItems: "center"}}><span style={{color: modal.data.color}}>{modal.data.title}</span><h4 style={{marginBottom: "0", color: modal.data.color, marginLeft: " 20px"}}>{modal.data.color == "#28a745" && "Success"}{modal.data.color == "#17a2b8" && "Info"}{modal.data.color == "#ffc107" && "Warning"}{modal.data.color == "#dc3545" && "problem"}</h4></div></Modal.Header>
                <Modal.Body><span style={{color: modal.data.color}}>{modal.data.html}</span></Modal.Body>
                <Modal.Footer><button className="add-new-button" style={{width: "100px"}} onClick={() => setModal((prev) => ({...prev, show: false}))}>Ok</button></Modal.Footer>
            </Modal>
        </>
    )
}

export default Header